import React from "react"
import { Box, Radio, Typography, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { tailwindPalette } from "../../../../../../modules/theme/tailwindPalette"
import { LocalizedEnum, LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"

const useStyles = makeStyles()(() => ({
    container: {
        padding: ".5rem 1rem",
        maxWidth: "20rem",
    },
    option: {
        display: "flex",
        alignItems: "flex-start",
        border: "1px solid #E0E0E0",
        borderRadius: "0.75rem",
        padding: "0.75rem",
        cursor: "pointer",
        transition: "border-color 0.2s",
        "&:hover": {
            borderColor: tailwindPalette.blue[500],
        },
    },
    selected: {
        borderColor: tailwindPalette.blue[500],
    },
    radio: {
        padding: "0.25rem",
        marginRight: "0.5rem",
    },
}))

type SwitcherFilterProps = {
    value?: string | null
    identifier: string
    setValue: (value: string) => void
}

export function SwitcherFilter({ value, setValue, identifier }: SwitcherFilterProps) {
    const { classes, cx } = useStyles()

    return (
        <Box className={classes.container}>
            <LocalizedEnum base="resource-booking-chip-filter-select-title" enumValue={identifier}>
                <Typography fontWeight={600} paddingLeft="1rem" marginBottom="1rem">
                    Select
                </Typography>
            </LocalizedEnum>
            <Stack spacing="0.5rem">
                <Box
                    className={cx(classes.option, { [classes.selected]: value === "internal" })}
                    onClick={() => setValue("internal")}
                >
                    <Radio checked={value === "internal"} className={classes.radio} />
                    <Box>
                        <LocalizedStrict id="resource-booking-chip-filter-select-meeting-type-title-internal-meeting">
                            <Typography variant="body1" fontWeight={600}>
                                Internal meeting
                            </Typography>
                        </LocalizedStrict>
                        <LocalizedStrict id="resource-booking-chip-filter-select-meeting-type-title-internal-meeting-description">
                            <Typography variant="body2" color="textSecondary">
                                The meeting is with coworkers only, no external guests.
                            </Typography>
                        </LocalizedStrict>
                    </Box>
                </Box>

                <Box
                    className={cx(classes.option, { [classes.selected]: value === "external" })}
                    onClick={() => setValue("external")}
                >
                    <Radio checked={value === "external"} className={classes.radio} />
                    <Box>
                        <LocalizedStrict id="resource-booking-chip-filter-select-meeting-type-title-external-meeting">
                            <Typography variant="body1" fontWeight={600}>
                                External meeting
                            </Typography>
                        </LocalizedStrict>
                        <LocalizedStrict id="resource-booking-chip-filter-select-meeting-type-title-external-meeting-description">
                            <Typography variant="body2">Meeting has external guests.</Typography>
                        </LocalizedStrict>
                    </Box>
                </Box>
            </Stack>
        </Box>
    )
}
